import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedSection } from '../store/dashboardSlice'

const getTopicId = t => String(t.topic_id ?? t.id ?? t.PK)

const findTopicInTree = (nodes, targetId) => {
  for (const node of nodes) {
    if (getTopicId(node) === targetId) return node
    if (node.children) {
      const found = findTopicInTree(node.children, targetId)
      if (found) return found
    }
  }
  return null
}

export default function ProfileComponent({ setIsKbNavbarMode, selectTopic }) {
  const dispatch = useDispatch()
  const user = useSelector(state => state.dashboard.user)
  const topics = useSelector(state => state.dashboard.topics)
  const lastTopicKey = user ? `last_topic_${user.id}` : ''
  const lastItemKey = user ? `last_item_${user.id}` : ''
  const lastTopicId = lastTopicKey ? localStorage.getItem(lastTopicKey) : null
  const lastItemData = lastItemKey ? localStorage.getItem(lastItemKey) : null
  const lastItem = lastItemData ? JSON.parse(lastItemData) : null
  const lastTopic = lastTopicId ? findTopicInTree(topics, lastTopicId) : null
  return (
    <div className="content-panel profile-panel">
      <div className="profile-header">
        <div className="profile-info">
          <div className="profile-avatar">
            {user?.avatar ? (
              <img src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png?size=128`} alt="Profile" />
            ) : (
              <div className="profile-avatar-default">
                {user?.global_name?.[0] || user?.username?.[0] || 'U'}
              </div>
            )}
          </div>
          <div className="profile-details">
            <h2>Welcome, {user?.global_name || user?.username}</h2>
            <p className="profile-id">ID: {user?.id}</p>
            <div className="profile-stats"></div>
          </div>
        </div>
      </div>

      <div className="profile-content">
        <div className="profile-section">
          <h3>Recent Activity</h3>
          <div className="last-edit-cards">
            {lastTopic && (
              <div
                className="last-edit-card"
                onClick={() => {
                  dispatch(setSelectedSection('Knowledge Base'))
                  setIsKbNavbarMode(true)
                  selectTopic(lastTopic)
                }}
              >
                <div className="card-icon">📝</div>
                <div className="card-content">
                  <h4>Last Topic</h4>
                  <p>{lastTopic.title}</p>
                  <button className="resume-btn">Resume Editing</button>
                </div>
              </div>
            )}
            {lastItem && (
              <div
                className="last-edit-card"
                onClick={() => {
                  dispatch(setSelectedSection('Item Category'))
                  setIsKbNavbarMode(false)
                }}
              >
                <div className="card-icon">🛍️</div>
                <div className="card-content">
                  <h4>Last Item</h4>
                  <p>{lastItem.name}</p>
                  <button className="resume-btn">Resume Editing</button>
                </div>
              </div>
            )}
            {!lastTopic && !lastItem && (
              <div className="no-activity">
                <div className="empty-state-icon">🚀</div>
                <p>No recent activity. Start by creating a topic or item!</p>
              </div>
            )}
          </div>
        </div>

        <div className="profile-section">
          <h3>Keyboard Shortcuts</h3>
          <div className="shortcuts-grid">
            <div className="shortcuts-category">
              <h4>Navigation</h4>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>K</kbd>
                </div>
                <span>Open Knowledge Base</span>
              </div>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>I</kbd>
                </div>
                <span>Open Item Category</span>
              </div>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>P</kbd>
                </div>
                <span>Open Profile</span>
              </div>
            </div>

            <div className="shortcuts-category">
              <h4>Knowledge Base</h4>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>N</kbd>
                </div>
                <span>Create New Topic</span>
              </div>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>/</kbd>
                </div>
                <span>Focus Search</span>
              </div>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>P</kbd>
                </div>
                <span>Publish Panel</span>
              </div>
            </div>

            <div className="shortcuts-category">
              <h4>Item Category</h4>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>N</kbd>
                </div>
                <span>Focus New Item Form</span>
              </div>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>/</kbd>
                </div>
                <span>Focus Item Search</span>
              </div>
              <div className="shortcut-item">
                <div className="shortcut-keys">
                  <kbd>Ctrl</kbd> + <kbd>F</kbd>
                </div>
                <span>Focus Filter</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
